import styled from 'styled-components';

export const Container = styled.div`
  strong{
      margin-left: 0px;
      margin-right: 0px;
  }
  li{
    margin-left: 20px;
  }
`;
